var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-md-block d-lg-flex justify-content-between align-items-end"},[_c('div',[_c('h1',{staticClass:"text-rothek font-48 mb-20 mt-20"},[_vm._v(_vm._s(_vm.course.name))]),(_vm.course.shortDescription)?_c('div',{staticClass:"font-16 line-24",domProps:{"innerHTML":_vm._s(_vm.clearStyle(_vm.course.shortDescription))}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }